import {useTheme, VStack} from '@chakra-ui/react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
  getServiceColorGradient,
  getServiceIcon,
  ServiceColor,
  ServiceIcon,
} from '../../utils/sevices'

interface Props {
  icon: ServiceIcon
  color: ServiceColor
}

const ServiceBadge = ({icon, color}: Props) => {
  const theme = useTheme()

  return (
    <VStack
      justify='center'
      align='center'
      w={[14, null, 14]}
      minW={[14, null, 14]}
      h={[14, null, 14]}
      borderRadius='medium'
      color={theme.colors.brand.white}
      background={getServiceColorGradient(color)}>
      <FontAwesomeIcon icon={getServiceIcon(icon)} size='lg' />
    </VStack>
  )
}

export default ServiceBadge
